import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { PrimaryButton } from "../../BookingPortal/components/Shared";
import { clearError } from "../actions";
import { deepGet } from "../../../utils";

const styles = {
  style: {
    zIndex: 10000
  },
  bodyStyle: {
    color: "rgb(244, 67, 54)",
    fontWeight: "300",
    zIndex: "10000",
    padding: "1em 2em 1em 3em",
    lineHeight: "1.5em"
  },
  iconStyle: {
    fontSize: "22px",
    position: "absolute",
    fontWeight: "700",
    left: "-1.4em",
    top: "50%",
    marginTop: "-0.5em"
  },
  errorSpanStyle: {
    position: "relative"
  }
};

class ErrorNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
  componentDidUpdate = () => {
    const { error } = this.props;
    if (!!error && !this.state.open) {
      this.handleOpen();
    }
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.clearError();
  };

  renderAction = () => {
    return [
      <PrimaryButton
        label="OK"
        onClick={this.handleClose}
        style={{ fontSize: "14px" }}
      />
    ];
  };

  render() {
    const { error } = this.props;
    return (
      <Dialog
        actions={
          deepGet(error, ["canDismiss"], false) ? this.renderAction() : null
        }
        modal={true}
        open={error ? this.state.open : false}
        onRequestClose={this.handleClose}
        bodyStyle={styles.bodyStyle}
        style={styles.style}
      >
        <span style={styles.errorSpanStyle}>
          <i className="material-icons" style={styles.iconStyle}>
            close
          </i>
          {deepGet(error, ["text"])}
        </span>
      </Dialog>
    );
  }
}

const mapStateToProps = ({ general }) => {
  return { error: general.error };
};

export default connect(mapStateToProps, { clearError })(ErrorNotification);



// WEBPACK FOOTER //
// ./src/modules/Layout/components/ErrorNotification.js